import urls from 'src/constants/constants';
import apiAuth from 'src/clients/apiAuth';

export default {
  getUsers() {
    return apiAuth({
      method: 'get',
      baseURL: urls.url.userService.baseUrl,
      url: urls.url.userService.api.users,
    }).then((res) => res.data);
  },
  matchUserToSupplier(user, supplier) {
    if (!user || !supplier || !supplier.id) throw new Error('Could not match user, please provide userId/supplier');
    return apiAuth({
      method: 'patch',
      baseURL: urls.url.userService.baseUrl,
      url: urls.url.userService.api.matchSupplier(user.id, supplier.id),
    }).then((res) => res.data);
  },
  getUserByCreditorId(creditorId) {
    return apiAuth({
      method: 'get',
      baseURL: urls.url.userService.baseUrl,
      url: urls.url.userService.api.byCreditor(creditorId),
    }).then((res) => res.data);
  },
};
